/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

import { getBackgroundColour } from './helpers';
import { StyledCardBackgroundProps } from './types';

const baseStyles = ({ color, expandOnHover }: StyledCardBackgroundProps) => {
    const backgroundColor = getBackgroundColour(color);

    /* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
    return css`
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: var(--layout-spacing-16);

        .background {
            position: absolute;
            background-color: ${backgroundColor};
            width: 100%;
            height: 100%;
            border-radius: 0.8rem;
            box-shadow: var(--effects-shadow-base);
            transition-property: width, height, box-shadow;
            transition-duration: var(--animations-default-duration);
            transition-timing-function: var(
                --animations-default-timing-function
            );
        }

        ${
            expandOnHover &&
            css`
                @media (hover: hover) {
                    &:hover {
                        .background {
                            width: calc(100% + var(--layout-spacing-16));
                            height: calc(100% + var(--layout-spacing-16));
                            box-shadow: var(--effects-shadow-lg);
                        }
                    }
                }
            `
        }
    `;
    /* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
};

const tagStyles = ({ tag }: StyledCardBackgroundProps) => {
    if (!tag) return;

    /* eslint-disable @mpb-com/mpb/use-design-tokens, @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
    return css`
        .background {
            &:before {
                content: '';
                position: absolute;
                inset: 0;
                z-index: -1;
                margin: calc(var(--layout-spacing-2) * -1);
                border-radius: 1rem;
                background: linear-gradient(
                    to bottom,
                    var(--colors-brand-accent),
                    transparent
                );
            }
        }

        .tag {
            ${theme.typography.caption}
            z-index: 2;
            position: absolute;
            background-color: var(--colors-brand-accent);
            padding: var(--layout-spacing-4) var(--layout-spacing-8);
            top: 0;
            left: 0;
            border-radius: 0.8rem 0 0.8rem 0;
        }
    `;
    /* eslint-enable @mpb-com/mpb/use-design-tokens, @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
};

export const styles = (props: StyledCardBackgroundProps) => css`
    ${baseStyles(props)}
    ${tagStyles(props)}
`;
